<template>
	<div class="salsedetails">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">详情</div>
					<div class="contentcard" v-if="detailinfo">
						<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
							<a-col :span="8" style="text-align: center;">商品名称</a-col>
							<a-col :span="2" style="text-align: center;">单价</a-col>
							<a-col :span="2" style="text-align: center;">数量</a-col>
							<a-col :span="2" style="text-align: center;">买家</a-col>
							<a-col :span="4" style="text-align: center;">订单总金额</a-col>
							<a-col :span="4" style="text-align: center;">状态</a-col>
						</a-row>
						<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;font-size: 14px;">
							<a-col :span="10" style="text-align: center;">订单号：{{detailinfo.trade_number}}</a-col>
							<a-col :span="9" style="text-align: center;">创建时间：{{moment(detailinfo.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
							<a-col :span="5" style="text-align: center;">支付平台：{{detailinfo.trade_platform}}</a-col>
						</a-row>
						<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;font-size: 14px;"
						 v-for="(order,index) in detailinfo.TC_Orders" :key="index">
							<a-col :span="8" style="text-align: center;position: relative;">
								<div style="text-align: center;">
									<span>{{order.sku_title}}</span><br />
									<span>{{order.sku_properties}}</span>
								</div>
							</a-col>
							<a-col :span="2" style="text-align: center;">￥{{order.sku_price/100}}</a-col>
							<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
							<a-col :span="2" style="text-align: center;">
								<span>{{detailinfo.UIC_User.nick_name}}</span>

							</a-col>
							<a-col :span="4" style="text-align: center;">
								<span>
									总价：￥ {{order.sku_price*order.amount/100}} <br>
									应付：￥ {{order.receipt_price/100}} <br>
									优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}
								</span>
							</a-col>
							<a-col :span="4" style="text-align: center;color: #0099FF;font-weight: 700;">{{status[order.order_status]}}</a-col>
						</a-row>
						<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;font-size: 14px;">
							<a-col :span="3" style="">收件人姓名：{{detailinfo.receiver_name}}</a-col>
							<a-col :span="6" style="">收件人手机号码：{{detailinfo.receiver_phone}}</a-col>
							<a-col :span="10" style="">地址：{{detailinfo.receiver_address}}</a-col>
						</a-row>
						<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;font-size: 14px;">
							<a-col :span="24">
								<div>买家备注：</div>
								<span>{{detailinfo.remarks}}</span>
							</a-col>
						</a-row>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	import moment from 'moment';

	export default {

		data() {
			return {
				current: ['bdmanagement'],
				openKeys: ['bdmodule'],
				dateFormat: 'YYYY-MM-DD',
				detailinfo: null,
				status: {
					'to_be_paid': '待付款',
					'have_paid': '待发货',
					'delivery': '已发货',
					'finished': '已完成',
					'success': '交易成功',
					'refund': '退款售后',
					'closed': '已取消',
				},
			}
		},
		created: function() {
			var self = this;
			var params = {
				id: this.$route.query.id,
			};
			this.$axios.get('/bd/tradedetails', {
				params: params
			}).then(function(res) {
				self.detailinfo = res.data.tradedetail;

			});
		},
		methods: {
			moment
		},

	};
</script>

<style>

	.salsedetails .contentcard {
		padding: 24px;
		background-color: #fff;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?5bc31792